import { Field, Spinner } from '@chakra-ui/react';
import { ComingSoonIcon } from '@monetize/ui/icons';
import { ReactNode, forwardRef } from 'react';
import {
  MBox,
  MFormControl,
  MFormLabel,
  MIcon,
  MText,
} from '../../../components/Monetize';
import { MTooltip } from '../../../components/Monetize';

interface SettingsControlProps {
  name: string;
  heading: string;
  subheading?: string | ReactNode;
  fetchLoading?: boolean;
  isDisabled?: boolean;
  comingSoon?: boolean;
  formControlProps?: Field.RootProps;
  control: ReactNode;
}

export const SettingsControl = forwardRef(
  (
    {
      name,
      heading,
      subheading,
      fetchLoading = false,
      formControlProps,
      isDisabled = false,
      comingSoon = false,
      control,
    }: SettingsControlProps,
    ref,
  ) => {
    return (
      <MFormControl
        orientation="horizontal"
        width="full"
        gap="4"
        disabled={isDisabled}
        {...formControlProps}
      >
        <MBox flex="1" minW={0}>
          <MFormLabel htmlFor={name} fontSize="md" fontWeight="600">
            {heading}
            {comingSoon && (
              <MTooltip label="Coming Soon" shouldWrapChildren>
                <MIcon
                  ml="2"
                  as={ComingSoonIcon}
                  color="tGray.lightPurple"
                  cursor="pointer"
                  mb="-0.5"
                />
              </MTooltip>
            )}
          </MFormLabel>
          {typeof subheading === 'string' ? (
            <MText id={`${name}-subheading`}>{subheading}</MText>
          ) : (
            subheading
          )}
        </MBox>
        <MBox flexShrink={0}>
          {fetchLoading ? <Spinner size="md" /> : control}
        </MBox>
      </MFormControl>
    );
  },
);
